import { render, staticRenderFns } from "./MenuMainAction.vue?vue&type=template&id=50752f0c&scoped=true&"
import script from "./MenuMainAction.vue?vue&type=script&lang=js&"
export * from "./MenuMainAction.vue?vue&type=script&lang=js&"
import style0 from "./MenuMainAction.vue?vue&type=style&index=0&id=50752f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50752f0c",
  null
  
)

export default component.exports